(() => {
  const reduce = matchMedia('(prefers-reduced-motion: reduce)');
  const ready = new WeakSet();
  const cleanup = new WeakMap();
  function initAnnouncement(root) {
    if (ready.has(root)) return;
    ready.add(root);
    const messages = [...root.querySelectorAll('[data-er-announcement-message]')];
    let current = 0, paused = reduce.matches, hovered = false, focused = false, timer;
    const render = () => {
      messages.forEach((message, i) => message.hidden = i !== current);
    };
    const schedule = () => {
      clearInterval(timer);
      if (!paused && !hovered && !focused && !document.hidden && messages.length > 1) timer = setInterval(() => { current = (current + 1) % messages.length; render(); }, Math.max(5000, Number(root.dataset.interval) || 7000));
    };
    root.addEventListener('pointerenter', e => { if (e.pointerType === 'mouse') { hovered = true; schedule(); } });
    root.addEventListener('pointerleave', e => { if (e.pointerType === 'mouse') { hovered = false; schedule(); } });
    root.addEventListener('focusin', () => { focused = true; schedule(); });
    root.addEventListener('focusout', e => { focused = root.contains(e.relatedTarget); schedule(); });
    const motionChange = () => { if (reduce.matches) paused = true; render(); schedule(); };
    document.addEventListener('visibilitychange', schedule);
    reduce.addEventListener('change', motionChange);
    cleanup.set(root, () => { clearInterval(timer); document.removeEventListener('visibilitychange', schedule); reduce.removeEventListener('change', motionChange); });
    render(); schedule();
  }
  function initGallery(root) {
    if (ready.has(root)) return;
    ready.add(root);
    const slides = [...root.querySelectorAll('[data-er-gallery-slide]')];
    const buttons = [...root.querySelectorAll('[data-er-gallery-thumb]')];
    const show = index => {
      slides.forEach((slide, i) => slide.hidden = i !== index);
      buttons.forEach((button, i) => button.setAttribute('aria-pressed', String(i === index)));
    };
    buttons.forEach((button, index) => {
      button.addEventListener('click', () => show(index));
      button.addEventListener('keydown', e => {
        if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(e.key)) return;
        e.preventDefault();
        const next = e.key === 'Home' ? 0 : e.key === 'End' ? buttons.length - 1 : (index + (e.key === 'ArrowRight' ? 1 : -1) + buttons.length) % buttons.length;
        show(next); buttons[next].focus();
      });
    });
    root.addEventListener('shopify:block:select', e => { const index = slides.indexOf(e.target.closest('[data-er-gallery-slide]')); if (index >= 0) show(index); });
  }
  function initCalculator(root) {
    if (ready.has(root)) return;
    ready.add(root);
    const purchase = root.closest('[data-er-purchase]');
    const count = root.querySelector('[data-er-egg-count]');
    const days = root.querySelector('[data-er-pour-days]');
    const pick = root.querySelector('[data-er-calculator-pack]');
    const packs = [...purchase.querySelectorAll('[data-er-variant]')].filter(option => !option.disabled && Number(option.dataset.bottleCount) > 0).sort((a, b) => Number(a.dataset.bottleCount) - Number(b.dataset.bottleCount));
    let target;
    const render = () => {
      const eggs = Math.min(60, Math.max(1, Math.round(Number(count.value) || 1)));
      const period = Number(days.value);
      const ml = eggs * 30;
      const volumeBottles = Math.ceil(ml * period / 500);
      const bottles = Math.max(volumeBottles, Math.ceil(period / 2));
      root.querySelector('[data-er-ml]').textContent = `${ml} ml`;
      root.querySelector('[data-er-tbsp]').textContent = `${eggs * 2} tbsp`;
      root.querySelector('[data-er-protein]').textContent = `${eggs * 3}g`;
      root.querySelector('[data-er-volume-summary]').textContent = `${(ml * period).toLocaleString()} ml for ${period} ${period === 1 ? 'day' : 'days'}`;
      root.querySelector('[data-er-bottle-summary]').textContent = `${bottles} × 500 ml ${bottles === 1 ? 'bottle' : 'bottles'}`;
      root.querySelector('[data-er-freshness]').textContent = ml * 2 < 500 && period > 1 ? 'This estimate allows a fresh bottle every 2 days. Share or cook unused egg white within that time; the volume alone would use fewer bottles.' : 'Keep refrigerated at 4°C or below. Use each opened bottle within 2 days and follow its printed use-by date.';
      target = packs.find(option => Number(option.dataset.bottleCount) >= bottles) || packs.at(-1);
      pick.hidden = !target;
      if (target) {
        const packCount = Number(target.dataset.bottleCount);
        pick.firstChild.textContent = `${bottles > packCount ? 'Start with' : 'Choose'} a ${packCount}-bottle pack `;
      }
      root.querySelector('[data-er-step="-1"]').disabled = eggs <= 1;
      root.querySelector('[data-er-step="1"]').disabled = eggs >= 60;
    };
    count.addEventListener('input', render);
    count.addEventListener('change', () => { count.value = Math.min(60, Math.max(1, Math.round(Number(count.value) || 1))); render(); });
    days.addEventListener('change', render);
    root.querySelectorAll('[data-er-step]').forEach(button => button.addEventListener('click', () => { count.value = Math.min(60, Math.max(1, (Number(count.value) || 1) + Number(button.dataset.erStep))); render(); }));
    pick.addEventListener('click', () => {
      if (!target) return;
      target.checked = true; target.dispatchEvent(new Event('change', { bubbles: true }));
      const buy = purchase.querySelector('.er-product-buy-box');
      buy.scrollIntoView({ behavior: reduce.matches ? 'auto' : 'smooth', block: 'start' });
      buy.focus({ preventScroll: true });
    });
    render();
  }
  function init(scope = document) {
    scope.querySelectorAll('[data-er-announcement]').forEach(initAnnouncement);
    scope.querySelectorAll('[data-er-gallery]').forEach(initGallery);
    scope.querySelectorAll('[data-er-calculator]').forEach(initCalculator);
  }
  document.addEventListener('shopify:section:load', e => init(e.target));
  document.addEventListener('shopify:section:unload', e => e.target.querySelectorAll('[data-er-announcement]').forEach(el => cleanup.get(el)?.()));
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(), { once: true }); else init();
})();

/* One-time trial offer in the cart drawer: HAPPYCUSTOMER = 10% off one one-time order (never combines with subscriptions). */
(() => {
  if (window.eggrawTrialOffer) return; window.eggrawTrialOffer = true;
  const style = document.createElement('style');
  style.textContent = '#cart-drawer .eg-trial-offer{margin:14px 0 0;padding:14px 16px;border:2px dashed #09291e;border-radius:12px;background:#fffdf0;color:#09291e;font-size:13px;line-height:1.45}#cart-drawer .eg-trial-offer strong{display:block;font-size:15px;font-weight:800;margin-bottom:2px}#cart-drawer .eg-trial-offer code{background:#ffdb00;border-radius:6px;padding:1px 6px;font-weight:800;font-family:inherit}#cart-drawer .eg-trial-offer a{display:inline-block;margin-top:8px;font-weight:800;color:#005747;text-decoration:underline;text-underline-offset:3px}';
  document.head.append(style);
  const update = () => {
    const items = document.querySelector('#cart-drawer .cart-drawer__items');
    if (!items) return;
    const hasItem = !!items.querySelector('a[href*="/products/"]');
    let box = items.querySelector('.eg-trial-offer');
    if (hasItem && !box) {
      box = document.createElement('section'); box.className = 'eg-trial-offer';
      box.innerHTML = '<strong>Just want to try EggRaw once?</strong>Get 10% off this one-time order with code <code>HAPPYCUSTOMER</code>.<br><a href="/discount/HAPPYCUSTOMER?redirect=/checkout">Apply 10% off &amp; checkout →</a>';
      items.appendChild(box);
    }
    if (box) box.hidden = !hasItem;
  };
  let queued = false;
  new MutationObserver(() => { if (queued) return; queued = true; requestAnimationFrame(() => { queued = false; update(); }); }).observe(document.documentElement, { childList: true, subtree: true });
  update();
})();
